// assets/aumeto-featured-products.js

document.addEventListener('DOMContentLoaded', function() {
  // Get all featured product sections (in case there are multiple)
  const sections = document.querySelectorAll('.featured-products-section');
  
  sections.forEach(section => {
    initializeSection(section);
  });
});

function initializeSection(section) {
  const track = section.querySelector('.products-track');
  const prevBtn = section.querySelector('.carousel-prev');
  const nextBtn = section.querySelector('.carousel-next');
  const cards = section.querySelectorAll('.product-card');
  
  if (!track || !prevBtn || !nextBtn || cards.length === 0) return;
  
  let currentIndex = 0;
  let cardsPerView = 4;
  let isTransitioning = false;
  
  // Clone cards for infinite loop
  const firstClones = [];
  const lastClones = [];
  
  // Clone first and last sets of cards
  for (let i = 0; i < cardsPerView; i++) {
    if (cards[i]) {
      const lastClone = cards[i].cloneNode(true);
      lastClone.classList.add('clone');
      lastClones.push(lastClone);
    }
    
    const lastIndex = cards.length - 1 - i;
    if (cards[lastIndex]) {
      const firstClone = cards[lastIndex].cloneNode(true);
      firstClone.classList.add('clone');
      firstClones.unshift(firstClone);
    }
  }
  
  // Add clones to track
  firstClones.forEach(clone => track.insertBefore(clone, track.firstChild));
  lastClones.forEach(clone => track.appendChild(clone));
  
  // Get all cards including clones
  const allCards = track.querySelectorAll('.product-card');
  
  function calculateCardsPerView() {
    const carousel = section.querySelector('.products-carousel');
    if (!carousel) return;
    
    const containerWidth = carousel.offsetWidth;
    const cardWidth = allCards[0].offsetWidth + 24; // Including gap
    cardsPerView = Math.floor(containerWidth / cardWidth);
  }
  
  function updateCarousel(animate = true) {
    const cardWidth = allCards[0].offsetWidth + 24;
    const offset = -(currentIndex + cardsPerView) * cardWidth; // Account for prepended clones
    
    if (animate) {
      track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
    } else {
      track.style.transition = 'none';
    }
    
    track.style.transform = `translateX(${offset}px)`;
  }
  
  function moveToNext() {
    if (isTransitioning) return;
    isTransitioning = true;
    
    currentIndex++;
    updateCarousel();
    
    // Check if we've reached the end
    if (currentIndex >= cards.length) {
      setTimeout(() => {
        track.style.transition = 'none';
        currentIndex = 0;
        updateCarousel(false);
        setTimeout(() => {
          isTransitioning = false;
        }, 50);
      }, 500);
    } else {
      setTimeout(() => {
        isTransitioning = false;
      }, 500);
    }
  }
  
  function moveToPrev() {
    if (isTransitioning) return;
    isTransitioning = true;
    
    currentIndex--;
    updateCarousel();
    
    // Check if we've reached the beginning
    if (currentIndex < 0) {
      setTimeout(() => {
        track.style.transition = 'none';
        currentIndex = cards.length - 1;
        updateCarousel(false);
        setTimeout(() => {
          isTransitioning = false;
        }, 50);
      }, 500);
    } else {
      setTimeout(() => {
        isTransitioning = false;
      }, 500);
    }
  }
  
  prevBtn.addEventListener('click', moveToPrev);
  nextBtn.addEventListener('click', moveToNext);
  
  // Quick View functionality for all cards including clones
  track.querySelectorAll('.quick-view-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const handle = this.dataset.productHandle;
      openQuickView(handle);
    });
  });
  
  // Add to cart AJAX for all cards including clones
  track.querySelectorAll('.product-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const formData = new FormData(this);
      const button = this.querySelector('.add-to-cart-btn');
      
      // Add loading state
      const originalText = button.innerHTML;
      button.innerHTML = '<svg class="spinner" width="20" height="20" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="4"></circle></svg>';
      button.disabled = true;
      
      addToCart(formData, false, () => {
        // Reset button state
        button.innerHTML = originalText;
        button.disabled = false;
      });
    });
  });
  
  // Auto-play functionality
  const carouselWrapper = section.querySelector('.products-carousel-wrapper');
  const enableAutoplay = carouselWrapper && carouselWrapper.dataset.autoplay === 'true';
  const autoplaySpeed = (carouselWrapper && parseInt(carouselWrapper.dataset.autoplaySpeed)) || 5;
  
  let autoPlayInterval = null;
  
  const startAutoPlay = () => {
    if (!enableAutoplay) return;
    stopAutoPlay();
    autoPlayInterval = setInterval(moveToNext, autoplaySpeed * 1000);
  };
  
  const stopAutoPlay = () => {
    if (autoPlayInterval) {
      clearInterval(autoPlayInterval);
      autoPlayInterval = null;
    }
  };
  
  // Pause auto-play on hover
  if (enableAutoplay) {
    track.addEventListener('mouseenter', stopAutoPlay);
    track.addEventListener('mouseleave', startAutoPlay);
    prevBtn.addEventListener('mouseenter', stopAutoPlay);
    nextBtn.addEventListener('mouseenter', stopAutoPlay);
    prevBtn.addEventListener('mouseleave', startAutoPlay);
    nextBtn.addEventListener('mouseleave', startAutoPlay);
    
    // Start auto-play
    startAutoPlay();
  }
  // Initialize and handle resize
  calculateCardsPerView();
  updateCarousel(false);
  
  window.addEventListener('resize', () => {
    calculateCardsPerView();
    updateCarousel(false);
  });
}

// Format money helper function
function formatMoney(cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents);
  }
  // Fallback formatting
  return '$' + (cents / 100).toFixed(2);
}

// Quick View Modal Function
function openQuickView(handle) {
  // Show loading state
  showNotification('Loading product details...', 'info');
  
  fetch(`/products/${handle}.js`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Product not found');
      }
      return response.json();
    })
    .then(product => {
      // Hide loading notification
      const loadingNotif = document.querySelector('.cart-notification-info');
      if (loadingNotif) {
        loadingNotif.remove();
      }
      
      // Calculate savings
      const savings = product.compare_at_price && product.compare_at_price > product.price 
        ? product.compare_at_price - product.price 
        : 0;
      const savingsPercent = savings > 0 
        ? Math.round((savings / product.compare_at_price) * 100) 
        : 0;
      
      const modal = document.createElement('div');
      modal.className = 'quick-view-modal';
      
      // Create product images carousel HTML
      let imagesHTML = '';
      if (product.images && product.images.length > 0) {
        imagesHTML = `
          <div class="quick-view-images">
            <div class="main-image">
              <img src="${product.images[0]}" alt="${product.title}" id="quick-view-main-image">
            </div>
            ${product.images.length > 1 ? `
              <div class="image-thumbnails">
                ${product.images.map((img, index) => `
                  <img src="${img}" 
                       alt="${product.title} ${index + 1}" 
                       class="thumbnail ${index === 0 ? 'active' : ''}"
                       data-image="${img}">
                `).join('')}
              </div>
            ` : ''}
          </div>
        `;
      } else if (product.featured_image) {
        imagesHTML = `
          <div class="quick-view-images">
            <div class="main-image">
              <img src="${product.featured_image}" alt="${product.title}" id="quick-view-main-image">
            </div>
          </div>
        `;
      } else {
        imagesHTML = `
          <div class="quick-view-images">
            <div class="main-image placeholder-image">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="#B2DAF4">
                <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
              </svg>
            </div>
          </div>
        `;
      }
      
      // Build variant options
      let variantOptionsHTML = '';
      if (product.variants && product.variants.length > 1) {
        variantOptionsHTML = `
          <div class="variant-selector">
            <label>Options:</label>
            <select name="id" class="quick-view-variants">
              ${product.variants.map(v => 
                `<option value="${v.id}" ${!v.available ? 'disabled' : ''}>
                  ${v.title}${!v.available ? ' - Sold Out' : ''}
                </option>`
              ).join('')}
            </select>
          </div>
        `;
      } else if (product.variants && product.variants.length > 0) {
        variantOptionsHTML = `<input type="hidden" name="id" value="${product.variants[0].id}">`;
      }
      
      // Create modal HTML
      modal.innerHTML = `
        <div class="quick-view-overlay"></div>
        <div class="quick-view-content">
          <button class="quick-view-close">&times;</button>
          <div class="quick-view-body">
            ${imagesHTML}
            <div class="quick-view-info">
              <h2>${product.title || 'Product'}</h2>
              ${product.vendor ? `<p class="quick-view-vendor">Brand: ${product.vendor}</p>` : ''}
              
              <!-- Price Section -->
              <div class="quick-view-price-section">
                <div class="quick-view-price">
                  ${product.compare_at_price && product.compare_at_price > product.price ? 
                    `<span class="price-compare">${formatMoney(product.compare_at_price)}</span>` : ''}
                  <span class="price-current">${formatMoney(product.price)}</span>
                </div>
                ${savingsPercent > 0 ? `
                  <div class="quick-view-savings">
                    <span class="savings-badge">Save ${savingsPercent}%</span>
                    <span class="savings-amount">You save: ${formatMoney(savings)}</span>
                  </div>
                ` : ''}
              </div>
              
              <!-- Stock Status -->
              <div class="quick-view-stock">
                ${product.available ? 
                  `<span class="in-stock">✓ In Stock</span>` : 
                  `<span class="out-of-stock">✗ Out of Stock</span>`
                }
              </div>
              
              <!-- Description -->
              ${product.description ? 
                `<div class="quick-view-description">
                  <h4>Description:</h4>
                  <div class="description-content">${product.description.substring(0, 300)}${product.description.length > 300 ? '...' : ''}</div>
                </div>` : 
                ''}
              
              <!-- Add to Cart Form -->
              <form class="quick-view-form" id="quick-view-form">
                ${variantOptionsHTML}
                
                <div class="quick-view-quantity">
                  <label>Quantity:</label>
                  <div class="quantity-selector">
                    <button type="button" class="qty-btn qty-minus">−</button>
                    <input type="number" name="quantity" value="1" min="1" max="10" class="quantity-input" id="quick-view-quantity">
                    <button type="button" class="qty-btn qty-plus">+</button>
                  </div>
                </div>
                
                <button type="submit" class="quick-view-add-btn" ${!product.available ? 'disabled' : ''}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                  </svg>
                  ${product.available ? 'Add to Cart' : 'Sold Out'}
                </button>
              </form>
              
              <!-- Additional Actions -->
              <div class="quick-view-actions">
                <a href="/products/${handle}" class="quick-view-full">
                  View Full Details →
                </a>
              </div>
            </div>
          </div>
        </div>
      `;
      
      document.body.appendChild(modal);
      
      // Add event listeners
      const closeBtn = modal.querySelector('.quick-view-close');
      const overlay = modal.querySelector('.quick-view-overlay');
      const form = modal.querySelector('.quick-view-form');
      const qtyMinus = modal.querySelector('.qty-minus');
      const qtyPlus = modal.querySelector('.qty-plus');
      const qtyInput = modal.querySelector('#quick-view-quantity');
      const thumbnails = modal.querySelectorAll('.thumbnail');
      const mainImage = modal.querySelector('#quick-view-main-image');
      
      // Thumbnail click handlers
      if (thumbnails.length > 0 && mainImage) {
        thumbnails.forEach(thumb => {
          thumb.addEventListener('click', function() {
            // Update main image
            mainImage.src = this.dataset.image;
            // Update active thumbnail
            thumbnails.forEach(t => t.classList.remove('active'));
            this.classList.add('active');
          });
        });
      }
      
      // Quantity buttons
      if (qtyMinus && qtyPlus && qtyInput) {
        qtyMinus.addEventListener('click', () => {
          const currentVal = parseInt(qtyInput.value) || 1;
          if (currentVal > 1) {
            qtyInput.value = currentVal - 1;
          }
        });
        
        qtyPlus.addEventListener('click', () => {
          const currentVal = parseInt(qtyInput.value) || 1;
          if (currentVal < 10) {
            qtyInput.value = currentVal + 1;
          }
        });
      }
      
      // Close modal
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          modal.classList.add('closing');
          setTimeout(() => modal.remove(), 300);
        });
      }
      
      if (overlay) {
        overlay.addEventListener('click', () => {
          modal.classList.add('closing');
          setTimeout(() => modal.remove(), 300);
        });
      }
      
      // Handle form submission
      if (form) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const formData = new FormData(this);
          const button = this.querySelector('.quick-view-add-btn');
          
          // Add loading state
          const originalText = button.innerHTML;
          button.innerHTML = 'Adding...';
          button.disabled = true;
          
          addToCart(formData, true, () => {
            // Reset button and close modal
            button.innerHTML = originalText;
            button.disabled = false;
            modal.classList.add('closing');
            setTimeout(() => modal.remove(), 300);
          });
        });
      }
      
      // Handle ESC key
      const handleEsc = (e) => {
        if (e.key === 'Escape') {
          modal.classList.add('closing');
          setTimeout(() => modal.remove(), 300);
          document.removeEventListener('keydown', handleEsc);
        }
      };
      document.addEventListener('keydown', handleEsc);
    })
    .catch(error => {
      console.error('Error loading product:', error);
      
      // Hide loading notification
      const loadingNotif = document.querySelector('.cart-notification-info');
      if (loadingNotif) {
        loadingNotif.remove();
      }
      
      showNotification('Unable to load product details. Please try again.', 'error');
    });
}

// Unified add to cart function
function addToCart(formData, fromQuickView, callback) {
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Failed to add to cart');
    }
    return response.json();
  })
  .then(data => {
    // Show success notification
    showNotification('✓ Product added to cart!', 'success');
    
    // Update cart count if element exists
    updateCartCount();
    
    // Trigger cart drawer if your theme has one
    if (typeof window.Shopify !== 'undefined' && window.Shopify.onCartUpdate) {
      window.Shopify.onCartUpdate(data);
    }
    
    // Trigger custom cart update event
    document.dispatchEvent(new CustomEvent('cart:added', {
      detail: data
    }));
    
    if (callback) callback();
  })
  .catch(error => {
    console.error('Error:', error);
    showNotification('Error adding to cart. Please try again.', 'error');
    if (callback) callback();
  });
}

// Notification system
function showNotification(message, type = 'success') {
  // Remove any existing notifications
  const existingNotification = document.querySelector('.cart-notification');
  if (existingNotification) {
    existingNotification.remove();
  }
  
  const notification = document.createElement('div');
  notification.className = `cart-notification cart-notification-${type}`;
  notification.innerHTML = `
    <div class="notification-content">
      <span>${message}</span>
      <button class="notification-close">&times;</button>
    </div>
    ${type !== 'info' ? '<div class="notification-progress"></div>' : ''}
  `;
  
  document.body.appendChild(notification);
  
  // Animate in
  setTimeout(() => {
    notification.classList.add('show');
  }, 10);
  
  // Close button
  const closeBtn = notification.querySelector('.notification-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 300);
    });
  }
  
  // Auto close after 4 seconds (except for info messages)
  if (type !== 'info') {
    setTimeout(() => {
      if (notification && notification.parentElement) {
        notification.classList.remove('show');
        setTimeout(() => {
          if (notification && notification.parentElement) {
            notification.remove();
          }
        }, 300);
      }
    }, 4000);
  }
}

// Update cart count
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update cart count in header if element exists
      const cartCountElements = document.querySelectorAll('.cart-count, .cart-item-count, [data-cart-count]');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });
      
      // Update cart bubble if it exists
      const cartBubble = document.querySelector('.cart-count-bubble');
      if (cartBubble) {
        if (cart.item_count > 0) {
          cartBubble.style.display = 'flex';
          cartBubble.textContent = cart.item_count;
        } else {
          cartBubble.style.display = 'none';
        }
      }
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}